/**
 * The default server URL to open if no other was specified.
 */
export const DEFAULT_SERVER_URL = 'https://v3meet.viettelmeet.com';
